import './SearchTitle.scss';
import * as React from 'react';
import { getClasses } from 'src/utils/classFunctions';
import { classList } from 'src/utils/classList';

type Props = {
    readonly modificators?: ReadonlyArray<string>;
    readonly keyword?: string;
    readonly text?: string;
    readonly children: React.ReactNode;
};

export function SearchTitle(props: Props): JSX.Element {
    const { modificators = [], children, text, keyword } = props;

    return (
        <div className="g-container">
            <div className="g-row">
                <div className="g-col-xl-12 g-col-lg-6 g-col-md-4 g-col-sm-2">
                    <div className={classList(getClasses('lvo-search-title', modificators))}>
                        <h2 className="lvo-search-title__title">
                            {children}

                            {keyword
                                ? <strong>({keyword})</strong>
                                : null}
                        </h2>
                        {text
                            ? <div className="lvo-search-title__text">{text}</div>
                            : null}
                    </div>
                </div>
            </div>
        </div>
    );
}
